import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import "antd/dist/antd.min.css";
import Main from "./routes/Main";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </React.StrictMode>
);
